module.exports = __webpack_public_path__ + "static/img/hudun.18328338.png";